<script lang="ts">
  import Button from '../shared/Button.svelte';
  import Icon from '../icons/Icon.svelte';
</script>

<section id="try" class="final-cta">
  <div class="wrap">
    <h2 class="h-section">Eight seconds <em>is plenty.</em></h2>
    <p class="lede">
      Try the live prototype. No download. No signup. Open it, watch the Time Crystal drain, and see
      what an authenticator that respects you looks like.
    </p>
    <div class="actions">
      <Button href="/demo" variant="primary" size="lg">
        Launch the app
        <Icon name="arrow-right" size={16} />
      </Button>
      <Button href="#level0" variant="ghost" size="lg">Read the Level 0 spec</Button>
    </div>
  </div>
</section>

<style>
  .final-cta {
    text-align: center;
    padding: 120px 0;
    position: relative;
  }
  @media (max-width: 640px) {
    .final-cta {
      padding: 80px 0;
    }
  }
  :global([data-theme='modern']) .final-cta::before {
    content: '';
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: 800px;
    height: 400px;
    background: radial-gradient(
      ellipse at center,
      color-mix(in oklab, var(--accent) 18%, transparent),
      transparent 70%
    );
    filter: blur(40px);
    pointer-events: none;
  }
  .wrap {
    max-width: var(--max-w);
    margin: 0 auto;
    padding: 0 var(--gutter);
    position: relative;
    z-index: 1;
  }
  .h-section {
    font-size: clamp(32px, 5vw, 56px);
    font-weight: 700;
    letter-spacing: -0.035em;
    line-height: 1;
    margin-bottom: 28px;
  }
  .h-section em {
    font-family: var(--font-serif);
    font-style: italic;
    font-weight: 400;
    color: var(--accent);
  }
  :global([data-theme='brutalist']) .h-section {
    font-weight: 900;
  }
  :global([data-theme='brutalist']) .h-section em {
    color: var(--text);
  }
  .lede {
    max-width: 520px;
    margin: 0 auto 36px;
    font-size: clamp(16px, 1.7vw, 20px);
    color: var(--text-2);
    line-height: 1.55;
  }
  .actions {
    display: flex;
    gap: 12px;
    justify-content: center;
    flex-wrap: wrap;
  }
</style>
